export const getSingleReceipt = async (dataHouse, receiptId) => {
  const singleReceiptDetails = await dataHouse.find((data) => {
    return data.id === receiptId;
  });
  return singleReceiptDetails;
};
